import { createContext, useContext } from 'react';

import type { NavigationContextValue } from 'components/navigation/navigation_wrapper';

export const NavigationContext = createContext({} as NavigationContextValue);
NavigationContext.displayName = 'NavigationContext';

export const useNavigation = () => useContext(NavigationContext);
